
export interface SiteConfigDataActionTypes {
  type: SiteConfigDataActions;
  payload?: any;
}

export enum SiteConfigDataActions {
  SET_THEME_CONFIG_DATA = "SET_THEME_CONFIG_DATA",
}

interface ISetThemeConfigData {
  logo_img: string;
  colors: {
    primary_default: string;
    primary_dark: string;
    primary_medium: string;
    primary_light: string;
  };
}


export const setSiteThemeConfigData = (payload: ISetThemeConfigData) => ({
  type: SiteConfigDataActions.SET_THEME_CONFIG_DATA,
  payload
})